// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-step-editor-sidebar-media-images[data-v-09334142]{padding:16px;width:100%}.social-step-editor-sidebar-media-images__text[data-v-09334142]{text-align:center;color:#7d858e;font-size:12px;line-height:16px;margin:16px 0}.social-step-editor-sidebar-media-images__icon[data-v-09334142]{margin-left:10px;color:inherit;display:flex}", ""]);
// Exports
module.exports = exports;
